import {GeoLayer} from './GeoLayer';

export default GeoLayer;